import { getData, postData } from './redux_data';
import {
    GET_PRESUPUESTO, GET_PRESUPUESTO_DETALLE, GENERATE_PRESUPUESTO, GET_NEW_PRESUPUESTO_DETALLE, UPDATE_PRESUPUESTO_DETALLE, COPIAR_PRESUPUESTO, CAMBIAR_BLOQUEO_PRESUPUESTO,
} from '../constants/action_types';


export function getPresupuesto(centro_id, year, provisional) {
    return getData('presupuesto?centro_id=' + centro_id + '&actual_year=' + year + '&provisional=' + provisional, GET_PRESUPUESTO);
}

export function getPresupuestoDetalle(centro_id, actual_year, ref_year, month, zona_id, arcade, real, presupuesto_id) {
    return getData('presupuesto/detalle?centro_id=' + centro_id + '&actual_year=' + actual_year + '&ref_year=' + ref_year + '&month=' + month + '&zona_id=' + zona_id + '&arcade=' + arcade + '&real=' + real + '&presupuesto_id=' + presupuesto_id, GET_PRESUPUESTO_DETALLE);
}

//generate new presupuesto in DB (post):
export function generatePresupuesto(centro_id, actual_year, ref_year, start_month, end_month, real, provisional, parametros) {
    
    const postURL = 'presupuesto/generaPresupuesto?centro_id=' + centro_id +
    '&actual_year=' + actual_year + '&ref_year=' + ref_year + '&start_month=' + start_month + 
    '&end_month=' + end_month + '&real=' + real + '&provisional=' + provisional;
    
    return postData(postURL, GENERATE_PRESUPUESTO, parametros, undefined, undefined);

};

export function updatePresupuestoDetalle(zona_id, valores, presupuesto_id) {

    const postURL = 'presupuesto/actualizaMes?zona_id=' + zona_id + '&presupuesto_id=' + presupuesto_id;

    return postData(postURL, UPDATE_PRESUPUESTO_DETALLE, valores, undefined, undefined);

};

export function getNewPresupuestoDetalle(centro_id, actual_year, ref_year, month, i_tipozona, factor, real) {
    return getData('presupuesto/DetalleNuevo?centro_id=' + centro_id + '&actual_year=' + actual_year + '&ref_year=' + ref_year + '&month=' + month + '&i_tipozona=' + i_tipozona + '&factor=' + factor + '&real=' + real, GET_NEW_PRESUPUESTO_DETALLE);
}


export function copiarPresupuesto(presupuesto_id, prov_to_def)
{
    const postURL = 'presupuesto/CopiarPresupuesto?presupuesto_id=' + presupuesto_id + '&prov_to_def=' + prov_to_def;

    return postData(postURL, COPIAR_PRESUPUESTO, {}, undefined, undefined);
}

export function cambiarBloqueoPresupuesto(presupuesto_id)
{
    const postURL = 'presupuesto/BloquearPresupuesto?presupuesto_id=' + presupuesto_id;

    return postData(postURL, CAMBIAR_BLOQUEO_PRESUPUESTO, {}, undefined, undefined);

}